import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 6,
	viewBox: "0 0 5 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		y: .5,
		width: 5,
		height: 5,
		fill: "currentColor"
	})
});
export { SvgSquare as ReactComponent };
